module.exports = new __parcel__URL__("error-icon.fcea7b28.svg").toString();